import { render, staticRenderFns } from "./research.vue?vue&type=template&id=485a2f3d&scoped=true"
import script from "./research.vue?vue&type=script&lang=js"
export * from "./research.vue?vue&type=script&lang=js"
import style0 from "./research.vue?vue&type=style&index=0&id=485a2f3d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485a2f3d",
  null
  
)

export default component.exports